var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendSvgrepo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.945,
    height: 18.945,
    viewBox: "0 0 18.945 18.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send-svgrepo-com",
    d: "M10.3,13.695l9.8-9.8M10.58,14.135,12.8,18.58c.537,1.074.806,1.611,1.144,1.755a1,1,0,0,0,.9-.061c.316-.188.51-.756.9-1.893l4.2-12.3c.338-.99.507-1.485.391-1.813a1,1,0,0,0-.61-.61c-.328-.116-.823.053-1.813.391l-12.3,4.2c-1.136.388-1.7.582-1.893.9a1,1,0,0,0-.061.9c.144.338.681.607,1.755,1.144L9.864,13.42a2.107,2.107,0,0,1,.342.192,1,1,0,0,1,.181.181A2.105,2.105,0,0,1,10.58,14.135Z",
    transform: "translate(-2.571 -2.483)",
    fill: "none",
    stroke: "#2c7c2f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSvgrepo);
export default __webpack_public_path__ + "static/media/send-svgrepo-.ca9f14c7e5b7cc5914558a373279ccd9.svg";
export { ForwardRef as ReactComponent };